import {
    TASK_EQUIPMENT_RESET,
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN,
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS,
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR,
    EQUIPMENT_MODEL_UPDATE,
    EQUIPMENT_MODEL_UPDATE_SUCCESS,
    EQUIPMENT_MODEL_UPDATE_ERROR,
    EQUIPMENT_UNIT_UPDATE,
    EQUIPMENT_UNIT_UPDATE_SUCCESS,
    EQUIPMENT_UNIT_UPDATE_ERROR,
    EQUIPMENT_BULK_SAVE,
    EQUIPMENT_BULK_SAVE_SUCCESS,
    EQUIPMENT_BULK_SAVE_ERROR
} from '../actions';

const INIT_STATE = {
    loading: true,
    error: false,
    detail: {
        data: [],
        loading: false
    },
    bulkSave: {
        loading: false,
        message: ''
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case TASK_EQUIPMENT_RESET:
            return { ...INIT_STATE, detail: { data: [], loading: false } };
        case TASK_EQUIPMENT_LIST_DELIVERY_PLAN:
            return { ...state, loading: true };
        case TASK_EQUIPMENT_LIST_DELIVERY_PLAN_SUCCESS:
            return { ...state, loading: false, detail: { ...state.detail, data: action.payload } };
        case TASK_EQUIPMENT_LIST_DELIVERY_PLAN_ERROR:
            return { ...state, loading: false, error: true };
        case EQUIPMENT_MODEL_UPDATE:
            return { ...state };
        case EQUIPMENT_MODEL_UPDATE_SUCCESS:
            return { ...state };
        case EQUIPMENT_MODEL_UPDATE_ERROR:
            return { ...state };
        case EQUIPMENT_UNIT_UPDATE:
            return { ...state };
        case EQUIPMENT_UNIT_UPDATE_SUCCESS:
            return { ...state };
        case EQUIPMENT_UNIT_UPDATE_ERROR:
            return { ...state };
        case EQUIPMENT_BULK_SAVE:
            return { ...state, bulkSave: { ...state.bulkSave, loading: true } };
        case EQUIPMENT_BULK_SAVE_SUCCESS:
            return { ...state, bulkSave: { ...state.bulkSave, loading: false, message: action.payload.message } };
        case EQUIPMENT_BULK_SAVE_ERROR:
            return { ...state, bulkSave: { ...state.bulkSave, loading: false, message: action.payload } };
        default:
            return state;
    }
};
